<template>
  <div class="columns is-centered">
    <div class="column is-half">
      <b-field label="Name">
        <b-input v-model="name" placeholder="Sanderson Horowitz"></b-input>
      </b-field>
      <b-field label="Message">
        <b-input v-model="message" maxlength="200" type="textarea" placeholder="Type your message here..."></b-input>
      </b-field>
      <b-field>
        <b-upload v-model="dropFiles" multiple drag-drop>
          <section class="section">
            <div class="content has-text-centered">
              <p><b-icon icon="upload" size="is-large"></b-icon></p>
              <p>Drop your files here or click to upload</p>
            </div>
          </section>
        </b-upload>
      </b-field>
      <div class="tags">
        <span v-for="(file, index) in dropFiles" :key="index" class="tag is-primary" >
          {{file.name}}
          <button class="delete is-small" type="button" @click="deleteDropFile(index)"></button>
        </span>
      </div>
      <b-field>
        <p class="control">
          <button @click="sendFile" class="button is-primary">Send File</button>
        </p>
      </b-field>
      <b-field>
        <p class="control">
          <button @click="storeValues" class="button is-primary">Send message</button>
        </p>
      </b-field>
    </div>
  </div>
</template>

<script>
import * as firebase from "../firebase"

export default {
  name: 'FormOne',
  data: function() {
    return {
      name: "",
      message: "",
      dropFiles: []
    }
  },
  methods: {
    storeValues: function() {
      this.$store.commit("setMessage", {name: this.name, message: this.message});
      this.$buefy.toast.open({
        message: 'Message saved!',
        type: 'is-success',
        position: "is-top"
      });
    },
    sendFile: function() {

      // Logging for dev purposes
      console.log(this.dropFiles);
    
      // Create a storage reference from our storage service
      var storageRef = firebase.storage.ref();

      // Create a child reference and upload file
      storageRef.child(`materials/${this.dropFiles[0].name}`)
        .put(this.dropFiles[0]).then(function(snapshot) {
          console.log("File uploaded! " + snapshot);
        });
    },
    deleteDropFile: function(index) {
      this.dropFiles.splice(index, 1);
    }
  }
}
</script>

<style scoped>
</style>
